export default "__VITE_ASSET__DhHTHIef__"